import { BpmnModelJsonHelper } from '@edp-bif/common-api';
import { IRtShowEntity } from './IRtShowEntity';
import { AbstractShowEntity } from './AbstractShowEntity';

export class RtShowEntity extends AbstractShowEntity implements IRtShowEntity {
    isEnabled: boolean;

    protected ResetBeforeLoadFrom(): void {
        super.ResetBeforeLoadFrom();

        this.isEnabled = false;
    }

    public ConvertToJsonObject(): {} {
        let obj = super.ConvertToJsonObject();

        BpmnModelJsonHelper.SetAttributeValue(obj, "isEnabled", this.isEnabled);

        return obj;
    }

    public LoadFromJsonObject(obj: {}): void {
        super.LoadFromJsonObject(obj);

        this.isEnabled = BpmnModelJsonHelper.GetAttributeValueAsBoolean(obj, "isEnabled");
    }
}